import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import ApostolS1 from "../../components/apostolS1";
import ApostolS2 from "../../components/apostolS2";
import ApostolS3 from "../../components/apostolS3";



const ApostolPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Apostol')}/>
            <ApostolS1/>
            <ApostolS2/>
            <ApostolS3/>
        </section>
    );
};

export default ApostolPage;